import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "xy-wrap" }

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'ysxy',
  setup(__props) {

const text = ref(`
概要
我们严格遵守法律法规，遵循隐私保护原则，为您提供更加安全、可靠的服务。 万川AI新媒体产品（以下简称“万川AI新媒体”或“本产品”）是由广东省灵泽万川人工智能科技有限公司（以下简称“我们”）提供的视频剪辑产品，我们的注册地为广东省佛山市南海区。 您可以通过阅读本隐私保护指引详细了解我们对个人信息的收集、使用方式，以便您更好地了解我们的服务并作出适当的选择。

1.我们收集的信息在您使用本产品及/或服务的过程中，我们将根据合法、正当、必要的原则收集信息，我们收集或请您提供的信息将用于保障产品的基础正常运行；实现各项功能和服务；优化、改善产品和服务；保障产品、服务以及用户使用安全；遵循法律法规与国家的相关规定。 我们会按照如下方式主动收集您在使用服务时主动提供的或因为使用服务而产生的信息，用以向您提供服务、优化我们的服务以及保障您的账户安全：为保障本产品及服务的正常运行，当您使用本产品及/或服务时，我们会收集您的硬件型号、操作系统版本号、网络设备硬件地址（MAC）、唯一设备识别码、IP地址、软件版本号、网络接入方式及类型、操作日志等信息。请您了解，这些信息是我们提供服务和保障产品正常运营所必须收集的基本信息。相应功能中，如果您提供的是他人个人信息，请您确保已取得相关主体的授权，我们保留随时核查该等个人信息合法来源的权利。 当您登录本产品时，需要您通过手机号及验证码进行登录，并在您同意本隐私政策后，同步为您创建万川AI新媒体账号。如果您不同意本产品获取您的手机号及验证码进行登录，将会影响您使用万川AI新媒体产品的相关功能。 当您使用个性化编辑视频等功能或服务时，我们将会在您确认后访问本地相册，您可以导入视频文件并使用相关功能进行编辑。 为了提升您的用户体验，我们将收集您在“字幕识别”功能中所补充输入部分的文字信息以进行数据分析，有针对性地优化文字识别功能。我们承诺，收集此等文字信息并非出于识别您个人身份的目的，我们会对相关数据进行去标识化脱敏处理，并遵照本隐私政策进行加密和保护，不会向任何第三方共享。如果您拒绝授权提供，不会影响您正常使用本产品其他功能与服务，同时您也可以通过“客服中心”，随时联系我们撤回以上同意。 为帮助我们更好地了解本产品及相关服务的运行情况，以便确保运行与提供服务的安全，我们可能记录网络日志信息，以及使用软件及相关服务的频率、崩溃数据、总体安装、使用情况、性能数据等信息。 当您使用本产品及相关服务时，我们可能会使用相关技术向您的设备发送一个或多个Cookie 或匿名标识符，以收集和存储您访问、使用本产品时的信息。我们可能会设置认证与保障安全性的Cookie 或匿名标识符，保障产品与服务的安全、高效运转，帮助我们改进服务效率，提升登录和响应速度。使用此类技术也可以帮助您省去重复选择个性化视频编辑功能的步骤和流程，帮助您获得更轻松的访问体验。请注意，当您更改您的浏览器设置来关闭Cookies或者使用浏览器的匿名浏览功能时，Cookies将不会继续收集您的个人信息，但是平台上相应的一些用于提升您的浏览体验的功能也将无法使用。 当您选择参加我们开展的有关营销活动时，根据活动需要您可提供姓名、通信地址、联系方式、银行账号等信息，具体以活动界面和另行向您告知的内容为准。这些信息是个人敏感信息，是您收到转账或者礼品所必要的，如果您拒绝提供这些信息，我们将可能无法向您转账或发放礼品。 收集、使用个人信息目的变更的处理：请您了解，随着我们业务的发展，可能会对本产品的功能和提供的服务有所调整变化。原则上，当新功能或服务与登录、视频编辑、个性化选择贴纸、美化工具编辑等场景相关时，收集与使用的个人信息将与原处理目的具有直接或合理关联。在与原目的无直接或合理关联的场景下，我们收集、使用您的个人信息，会再次进行告知，并征得您的同意。

2.此外，根据相关法律法规及国家标准，我们征得同意有以下例外情形：
与国家安全、国防安全等国家利益直接相关的；与公共安全、公共卫生、公共知情等重大公共利益直接相关的； 与犯罪侦查、起诉、审判和判决执行等直接相关的； 出于维护您或其他个人的生命、财产、声誉等重大合法权益但又很难得到本人同意的； 所收集的个人信息是您自行向社会公众公开的； 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道； 根据您要求签订和履行合同所必需的； 用于维护万川AI新媒体产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障； 为开展合法的新闻报道所必需的； 出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的； 法律法规规定的其他情形。 请您理解，我们向您提供的功能和服务是不断更新和发展的，如果某一功能或服务未在前述说明中且收集了您的信息，我们会通过页面提示、交互流程、网站公告等方式另行向您说明信息收集的内容、范围和目的，以征得您的同意。

3.请您注意，目前我们不会主动从广东省灵泽万川人工智能科技有限公司之外的第三方获取您的个人信息。如未来为业务发展需要从第三方间接获取您的个人信息，我们会在获取前向您告知个人信息的来源、类型及使用范围，如我们开展业务需进行的个人信息处理活动超出您原本向第三方提供个人信息时的授权同意范围，我们将在处理您该等个人信息前征得您的授权同意；此外，我们也将会严格遵守相关法律法规的规定，并要求第三方保障其提供的信息的合法性。

4.信息的存储 
4.1 信息存储的方式和期限
我们会通过安全的方式存储您的信息，包括本地存储（例如利用APP进行数据缓存）、数据库和服务器日志。
一般情况下，我们仅在为实现目的所必需的最短时间内保留您的个人信息，例如您的账号信息，在您未撤回、删除或未注销账号期间，我们会保留相关信息。超出必要期限后，我们将对您的个人信息进行删除或匿名化处理。但下列情况除外：
为遵守适用的法律法规等有关规定； 为遵守法院判决、裁定或其他法律程序的规定； 为遵守相关政府机关执法的要求。 
4.2 信息存储的地域
我们会按照法律法规规定，将在中华人民共和国境内收集的用户个人信息存储于境内。
当我们的产品或服务发生停止运营的情形时，我们将采取例如，推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。

5.信息安全 
5.1 安全保护措施
我们为您的信息提供相应的安全保障，以防止信息的丢失、不当使用、未经授权访问或披露。
我们严格遵守法律法规保护用户的通信秘密。 我们使用符合业界标准的安全保护措施以保障信息的安全。
例如，我们使用加密技术、匿名化处理等手段来保护您的个人信息。
我们建立专门的管理制度、流程和组织确保信息安全。
例如，我们严格限制访问信息的人员范围，要求他们遵守保密义务，并进行审查。
尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全，我们将尽力确保您提供给我们的个人信息的安全性。您知悉并理解，您接入我们的服务所用的系统和通讯网络，有可能因我们可控范围外的因素而出现问题。因此，我们强烈建议您采取积极措施保护个人信息的安全。
5.2 安全事件处置措施
若发生个人信息泄露等安全事件，我们会启动应急预案，阻止安全事件扩大，并以推送通知、公告等形式告知您。
我们谨此特别提醒您，本隐私政策提供的个人信息保护措施仅适用于万川AI新媒体产品及相关服务。一旦您离开万川AI新媒体产品及相关服务，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护您在万川AI新媒体产品及相关服务之外的网站提交的任何个人信息，无论您登录、浏览或使用上述软件、网站是否基于本产品的链接或引导。

6.我们如何使用信息 
我们严格遵守法律法规的规定以及与用户的约定，按照本隐私保护指引所述使用收集的信息，以向您提供更为优质的服务。
6.1 信息使用规则
我们会按照如下规则使用收集的信息：
我们会根据我们收集的信息向您提供各项功能与服务，包括个性化素材推荐功能等； 我们会根据您的账号信息及历史使用数据为您提供个性化服务，包括基于特征标签进行间接人群画像并向您推荐您可能感兴趣的内容，优化个性化服务的体验，并评估、改善我们的推荐效果。 我们会根据您使用万川AI新媒体产品的频率和情况、故障信息、性能信息等分析我们产品的运行情况，以确保服务的安全性，并优化我们的产品，提高我们的服务质量。我们不会将我们存储在分析软件中的信息与您提供的个人身份信息相结合。 我们会在本隐私保护指引所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。
6.2 告知变动目的后征得同意的方式
我们将会在本隐私保护指引所涵盖的用途内使用收集的信息。如我们使用您的个人信息，超出了与收集时所声称的目的及具有直接或合理关联的范围，我们将在使用您的个人信息前，再次向您告知并征得您的明示同意。

7.第三方数据处理及信息的公开披露 
目前，除法律法规、司法机关或行政主管部门的强制性要求外，我们不会主动共享或转让您的个人信息至第三方，如存在其他共享或转让您的个人信息或您需要我们将您的个人信息共享或转让至第三方情形时，我们会直接或确认第三方征得您对上述行为的明示同意。
7.1 为实现相关功能或服务与关联方共享
当您在使用万川AI新媒体及关联方提供的内容同步功能时，您在我们及关联方提供的产品间所接受的服务具有一致性。为方便统一管理您的信息，经过您的明示同意，我们可能会将您的个人信息与这些关联方共享。
当您选择通过特定第三方账号授权登录，并使用第三方所提供的相关功能时，功能提供方将遵照其自身的用户协议与隐私政策，经您明确同意后收集和处理为实现这些功能所必需的个人信息，包括但不限于：
（1）您可以通过采用第三方账号授权登录的方式，使用第三方提供的相关功能服务。为实现这一功能，服务提供方会使用经您授权在第三方账号内的相关信息（包括但不限于账号、头像、昵称等）。这些信息是实现相关功能的必要信息条件，可能包含个人敏感信息，拒绝提供该等信息不会影响您正常使用万川AI新媒体产品；
（2）当您使用万川AI新媒体产品提供的第三方服务提供方与第三方支付公司合作提供的钱包支付功能服务时，第三方支付公司需要收集您的姓名、银行卡类型及卡号、有效期及手机号码等信息。上述信息属于个人敏感信息，如果您拒绝提供该等信息，将仅会使您无法使用该功能，但不影响您正常使用万川AI新媒体的其他功能。
7.2 帮助您参加调研营销活动
当您选择参加万川AI新媒体举办的有关调研营销活动时，我们可能根据活动需要委托第三方调研机构收集您的姓名、通信地址、联系方式等信息。我们将要求此等第三方调研机构以不低于本隐私保护指引的保护水平确保您的个人信息的安全，并在未经您事先允许的情况下，不得将您的个人信息用于任何其他目的或用途。如果您拒绝提供此等信息，我们将可能无法向您提供礼品。
为提升您的用户体验，例如优化广告效果，我们需要向第三方合作伙伴等，分享已经匿名化或去标识化处理后的信息，要求其严格遵守我们关于数据隐私保护的措施与要求，包括但不限于根据数据保护协议、承诺书及相关数据处理政策进行处理，避免识别出个人身份，保障隐私安全。
我们不会向合作伙伴分享可用于识别您个人身份的信息（例如您的姓名或电子邮件地址），除非您事先明确授权。
我们不会对外公开披露所收集的个人信息，如必须公开披露时，我们会向您告知此次公开披露的目的、披露信息的类型及可能涉及的敏感信息，并征得您的明示同意。
随着我们业务的持续发展，万川AI新媒体有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本隐私保护指引所要求的标准继续保护或要求新的控制者继续保护您的个人信息。
除对违规账号、欺诈行为进行处罚公告时，万川AI新媒体会披露相关账号的必要信息外，我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的自主选择同意。我们公开披露您的个人信息会采用符合业界标准的安全保护措施。
另外，根据相关法律法规及国家标准，万川AI新媒体获得您同意后共享、转让、公开披露有以下例外情形：
与国家安全、国防安全等国家利益直接相关的； 与公共安全、公共卫生等重大公共利益直接相关的； 与犯罪侦查、起诉、审判和判决执行等直接相关的； 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的； 个人信息主体自行向社会公众公开个人信息的； 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；法律法规规定的其他情形。

8.您的权利 
我们非常重视您对个人信息的管理，并尽全力保护您对于您个人信息的访问、修改（更新或更正）、删除以及撤回授权同意的权利，以使您拥有充分的能力保障您的隐私和安全。
8.1 管理、撤回授权您的信息
您可以通过取消登录状态、关闭功能、更改应用程序权限等方式撤回您的同意、改变您授权我们继续收集个人信息的范围或撤回您的授权。请您理解，特定的业务功能和服务将需要您的信息才能得以完成，当您撤回同意或授权后，万川AI新媒体无法继续为您提供撤回同意或授权所对应的功能和服务，也不再处理您相应的个人信息。但您撤回同意或授权的决定，不会影响此前基于您的授权而开展的个人信息处理。
如果您认为万川AI新媒体违反法律法规规定或与您的约定收集、使用您的个人信息，您也可以通过网站内的“客服中心”，或直接发送电子邮件至我们的官方邮箱与我们取得联系，并要求删除您的相关个人信息。我们将尽快确认所涉问题，并由专人在验证您的用户身份后，及时予以回复与处理。
8.2 注销您的账号
您可以在万川AI新媒体产品官方网站中进入“客服中心”中申请注销您的账号，在您注销账号前，我们将验证您的个人身份、安全状态、设备信息等。您知悉并理解，注销账号的行为是不可逆的行为，一旦您注销账号，我们将停止为您提供相关服务。
8.3 投诉举报
在万川AI新媒体产品及相关服务的某些业务功能中，我们可能依据信息系统、算法等在内的非人工自动决策机制作出决定，如果这些决定显著影响您的合法权益，您可以通过“客服中心”提交您的反馈。
8.4 访问隐私政策
您可以在客户端内的“设置”－“隐私政策”查看本隐私保护指引的全部内容。
8.5 停止运营向您告知权利
如万川AI新媒体停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，并对所持有的您的个人信息进行删除或匿名化处理。
8.6例外
我们将无法在如下的情况下回应您的行权请求：
（1）如果请求的信息与我们履行法律法规规定的义务所相悖；
（2）如果请求的信息与国家安全、国防安全直接相关；
（3）如果请求的信息与公共安全、公共卫生、重大公共利益直接相关；
（4）如果请求的信息与犯罪侦查、起诉、审判和执行判决直接相关；
（5）如果我们有合理的证据证明您存在主观恶意或者滥用权利时；
（6）如果回应您和您用户的行权请求将会导致您或您用户或者其他个人、组织的合法利益受到严重损害；
（7）如果请求的信息涉及商业秘密。

9变更 
我们可能会适时对本隐私保护指引进行修订。当隐私保护指引的条款发生变更时，我们会在版本更新时以红点提示等方式向您提示变更后的隐私保护指引，并向您说明生效日期。
10未成年人保护 
我们非常重视对未成年人个人信息的保护。
根据相关法律法规的规定，若您是18周岁以下的未成年人，在使用万川AI新媒体产品及服务前，应事先取得您的家长或法定监护人的同意。
根据相关法律法规的规定，若您是14周岁以下的儿童，在使用万川AI新媒体产品及服务前，应当按照注册、使用流程，事先取得您的家长或法定监护人的同意，并由您的家长或法定监护人帮助您完成产品或服务注册流程，以便您能使用我们提供的产品或服务。
若您是儿童的监护人，当您在帮助儿童完成产品或服务的注册、使用前，应当仔细阅读本政策、产品具体的隐私保护指引（如有），决定是否同意本政策、产品具体的隐私保护指引（如有）。
对于经监护人同意使用本平台和服务而收集未成年人个人信息的情况，我们只会在法律法规允许、监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
如果您的监护人不同意您按照本政策使用我们的服务或向我们提供个人信息，请您立即终止使用我们的服务并及时通知我们。

11.其他
万川AI新媒体产品的《隐私政策》是我们统一适用的一般性隐私条款，其中所规定的用户权利及信息安全保障措施均适用于万川AI新媒体用户。如万川AI新媒体产品的《隐私政策》与本隐私保护指引存在不一致或矛盾之处，请以本隐私保护指引为准。
万川AI新媒体将不时更新本隐私保护指引。我们会在网页上发布对隐私保护指引所做的变更内容。若您不同意修改后的隐私政策，您有权并应立即停止使用我们的产品和/或服务。如果您继续使用我们的产品和/或服务，则视为您接受我们对本政策相关条款所做的修改。

12.联系我们 
我们设立了专门的个人信息保护团队和个人信息保护负责人，如果您对本隐私政策或个人信息保护相关事宜有任何疑问或投诉、建议时，您可以通过网站客服与我们联系，我们将尽快审核所涉问题，并在15个工作日或法律法规规定的期限内予以反馈。

`)

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("h3", { style: {"text-align":"center"} }, "万川AI新媒体平台隐私协议", -1)),
    _createVNode(_component_el_input, {
      type: "textarea",
      modelValue: text.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((text).value = $event)),
      rows: 30,
      readonly: ""
    }, null, 8, ["modelValue"])
  ]))
}
}

})